import { type LoaderFunctionArgs, type MetaFunction } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";
import { useBoardConfiguration } from "~/hooks/use_board_configuration";
import Confirmation from "~/shared/confirmation";
import useSeekSignal from "~/hooks/use_seek_signal";
import { fetchJobApplicationRequest } from "~/utils/fetch_job_application_request";
import { withNamespace } from "~/utils/translation";
import "~/shared/confirmation.scss";
import "~/components/typography.scss";
import "~/components/button.scss";
import "~/components/logo.scss";

export const meta: MetaFunction = () => {
  const t = withNamespace("confirmation");
  return [{ title: t("page_title") }];
};

type Params = {
  url_token: string;
  token: string;
};

export const loader = async ({ params }: LoaderFunctionArgs) => {
  const { url_token, token } = params as Params;
  const { jobApplicationRequest, status } = await fetchJobApplicationRequest({ token, url_token });

  if (status === 404 || jobApplicationRequest === undefined) {
    throw new Response(null, { status: 404 });
  }

  return {
    jobApplicationRequest,
    url_token,
    token,
  };
};

const JobApplicationRequestConfirmationPage = () => {
  const { jobApplicationRequest, url_token } = useLoaderData<typeof loader>();

  const { button_shape: buttonShape, logo: logoConfiguration } = useBoardConfiguration();

  useSeekSignal();

  return (
    <Confirmation
      internal={false}
      urlToken={url_token}
      jobPostId={jobApplicationRequest.data.greenhouse_job_application_id.toString()}
      jobPostPublicUrl={jobApplicationRequest.job_application.public_url}
      companyName={jobApplicationRequest.job_application.company_name}
      message={jobApplicationRequest.job_application.confirmation_message}
      buttonShape={buttonShape}
      logoConfiguration={logoConfiguration}
      isJobApplicationRequest={true}
    />
  );
};

export default JobApplicationRequestConfirmationPage;
